import { Image } from "react-bootstrap";
import styled from "styled-components";

export const StyledProductBadge = styled(Image)`
    top: 0px;
    height: 40px;
    position: absolute;
    left: -10px;
`;
